

















import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import RgsToggle from '@/components/RgsToggle.vue'
import { navigationSectionProps } from '@/mixins/navigationSectionProps'

export default defineComponent({
  name: 'NavigationSectionToggle',
  components: { RgsToggle },
  mixins: [navigationSectionProps],
  setup(props, { root }) {
    const activeSectionId = ref(props.children[0]?.id)
    const activeSection = computed(() =>
      props.children.find((child) => child.id === activeSectionId.value)
    )
    const toggleOptions = computed(() =>
      props.children.map((child) => {
        return {
          id: child.id,
          value: child.code,
          label: child.name,
        }
      })
    )

    const setActiveId = (id: string) => {
      activeSectionId.value = id
      root.$store.commit('navigation/SET_IS_SUBPAGE_OPEN', null)
    }

    return {
      toggleOptions,
      activeSectionId,
      activeSection,
      setActiveId,
    }
  },
})
